import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Sucursales = () => {
     useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  
  return (
    <div className="section-contacto">
      <div className="container mt-5">
        <h2 className="text-center font-weight-bold" data-aos="fade-up">Reclutamiento de personal</h2>
        <div className="mt-4" data-aos="fade-up">
            <p className="text-muted">
             ¿Quieres formar parte de nuestro equipo de trabajo?  En Ferretería El Constructor buscamos personas comprometidas, responsables y con deseos de superación. Explora los diferentes perfiles disponibles y encuentra la oportunidad ideal para ti.   
            </p>
      </div>
       
       <div className="banner">
        <h3 className="text-center mt-5 font-weight-bold">Bodeguero</h3>
        </div>
        <div className="row mt-4">
        <div className="col-md-6 text-center" data-aos="fade-right">
            <img src="./images/bodeguero.png" alt="Bodeguero" className="img-fluid img-sede" />
        </div>
        
        <div className="col-md-6" data-aos="fade-left">
            <h4 className="text-muted font-weight-bold mt-3">Funciones que debe cumplir el perfil:</h4>
            <ul className="text-muted text-justify ml-4 mt-2">
            <li>Recepción de mercadería.</li>
            <li>Despacho de mercadería.</li>
            <li>Control de inventarios y pedidos.</li>
            <li>Orden y limpieza en la bodega.</li>
            <li>Colaboración y coordinación con otras sucursales.</li>
            <li>Etc.</li>
            </ul>
            <div className="text-center mt-4">
            <a href="https://forms.gle/Qa5ka5zKApoUtAou7" target="_blank" rel="noopener noreferrer" className="btn-reclutamiento">
                Aplica aquí para el perfil
            </a>
            </div>
        </div>
        </div>

        <div className="banner">
          <h3 className="text-center mt-5 font-weight-bold">Asesor Comercial</h3>
        </div>
        <div className="row mt-4">
          <div className="col-md-6 text-center" data-aos="fade-right">
            <img src="./images/asesor.png" alt="Asesor Comercial" className="img-fluid img-sede" />
          </div>
          
          <div className="col-md-6" data-aos="fade-left">
             <h4 className="text-muted font-weight-bold mt-3">Funciones que debe cumplir el perfil:</h4>
             <ul className="text-muted text-justify ml-4 mt-2">
              <li>Atención al cliente.</li>
              <li>Brindar asesoramiento y soluciones adecuadas.</li>
              <li>Trabajo en equipo.</li>
              <li>Establecer y mantener relaciones sólidas con los clientes.</li>
              <li>Mantenerse actualizado sobre nuevos productos y técnicas de venta.</li>
              <li>Manejo de herramientas de ofimática.</li>
              <li>Etc.</li>
            </ul>
            <div className="text-center mt-4">
              <a href="https://forms.gle/U8fzqZbMSeXxQTH48" target="_blank" rel="noopener noreferrer" className="btn-reclutamiento">
                Aplica aquí para el perfil
              </a>
            </div>
          </div>
        </div>

        <div className="banner">
          <h3 className="text-center mt-5 font-weight-bold">Asistente contable administrativo</h3>
        </div>
        <div className="row mt-4">
          <div className="col-md-6 text-center" data-aos="fade-right">
            <img src="./images/asistentecontable.png" alt="asistente contable" className="img-fluid img-sede" />
          </div>
          
          <div className="col-md-6" data-aos="fade-left">
             <h4 className="text-muted font-weight-bold mt-3">Funciones que debe cumplir el perfil:</h4>
             <ul className="text-muted text-justify ml-4 mt-2">
              <li>Conciliaciones bancarias.</li>
              <li>Manejo de cuentas por cobrar y por pagar.</li>
              <li>Cumplimiento tributario.</li>
              <li>Atención al cliente.</li>
              <li>Manejo de facturas.</li>
              <li>Generación de reportes.</li>
              <li>Manejo de herramientas ofimáticas.</li>
              <li>Etc.</li>
            </ul>
            <div className="text-center mt-4">
              <a href="https://forms.gle/Cqfz1xwd7pf3TPtR7" target="_blank" rel="noopener noreferrer" className="btn-reclutamiento">
                Aplica aquí para el perfil
              </a>
            </div>
          </div>
        </div>


         <div className="banner">
          <h3 className="text-center mt-5 font-weight-bold">Operario de máquina (Figuradora de varillas)</h3>
        </div>
        <div className="row mt-4">
          <div className="col-md-6 text-center" data-aos="fade-right">
            <img src="./images/operariofiguradora.png" alt="operario figuradora" className="img-fluid img-sede" />
          </div>
          
          <div className="col-md-6" data-aos="fade-left">
             <h4 className="text-muted font-weight-bold mt-3">Funciones que debe cumplir el perfil:</h4>
             <ul className="text-muted text-justify ml-4 mt-2">
              <li>Conocimientos en figurados.</li>
              <li>Operar la máquina figuradora.</li>
              <li>Conocimiento de todo tipo de varillas.</li>
              <li>Control de calidad de figurados.</li>
              <li>Colaboración con el equipo.</li>
              <li>Etc.</li>
            </ul>
            <div className="text-center mt-4">
              <a href="https://forms.gle/ybfQ8Vc1zw2MzHA26" target="_blank" rel="noopener noreferrer" className="btn-reclutamiento">
                Aplica aquí para el perfil
              </a>
            </div>
          </div>
        </div>

        <div className="frase mt-4">
          ¡La rapidez nuestro compromiso, la variedad nuestra ventaja y la calidad nuestro respaldo!
        </div>
      </div>
    </div>
  );
};

export default Sucursales;